import { AllContentSVG, SelectContentSVG } from  '@/components/elements/combinedFeed/contentSVGs';
import { BasicButton } from 'thrive-components';


const FeedModeSelector = ({setFeedModeToAll, setFeedModeToSelected, isLoading}: {setFeedModeToAll: ()=> void, setFeedModeToSelected: ()=>void, isLoading: boolean}) => {
    return (
        <div className='feed-mode-selector'>
            <h1 className='feed-modal-title'>How do you want to add content?</h1>

            <div className='feed-mode-select-panel'>
                <div className='feed-mode-select'>
                    <div className='feed-mode-information'>
                        <div className='feed-mode-select-image'>
                            <AllContentSVG />
                        </div>

                        <span className='feed-mode-select-title'>All Available Content</span>

                        <span className='feed-mode-select-explainer'>Automatically include all content users can access, including new content as it’s published.</span>
                    </div>

                    <BasicButton 
                        className='feed-mode-button'
                        content={"Use all content"} 
                        ariaLabel={'Use all content in source list'}
                        onButtonClick={setFeedModeToAll}
                        isDisabled={isLoading}
                    />
                </div>

                <div className='feed-mode-select'>
                    <div className='feed-mode-information'>
                        <div className='feed-mode-select-image'>
                            <SelectContentSVG />
                        </div>

                        <span className='feed-mode-select-title'>Choose Sources</span>

                        <span className='feed-mode-select-explainer'>Select specific lists to build a feed form</span>
                    </div>

                    <BasicButton 
                        className='feed-mode-button'
                        content={"Select Lists"} 
                        ariaLabel={'Select content lists for source list'}
                        onButtonClick={setFeedModeToSelected}
                        isDisabled={isLoading}
                    />
                </div>
            </div>
        </div>
    );  
}

export default FeedModeSelector;